import { z } from "zod";
export const Role = z.enum(["admin", "supervisor", "rep"]);
export const LoginInput = z.object({ email: z.string().email().max(200), password: z.string().min(1).max(200) });
export const TotpInput = z.object({ code: z.string().regex(/^\d{6}$/, "Enter the 6-digit code") });
/** Same minimum as the server's PASSWORD_MIN. */
export const NEW_PASSWORD_MIN = 12;
export const ChangePasswordInput = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: z.string().min(NEW_PASSWORD_MIN, `Use at least ${NEW_PASSWORD_MIN} characters`).max(200),
});
export const CreateUserInput = z.object({
    email: z.string().email().max(200),
    name: z.string().trim().min(1).max(120),
    role: Role,
});
export const UpdateUserInput = z.object({
    name: z.string().trim().min(1).max(120).optional(),
    role: Role.optional(),
    active: z.boolean().optional(),
}).refine((v) => Object.keys(v).length > 0, "Nothing to update");
//# sourceMappingURL=auth.js.map